"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorMessageWithEmailLink = /** @class */ (function (_super) {
    __extends(ErrorMessageWithEmailLink, _super);
    function ErrorMessageWithEmailLink(props) {
        return _super.call(this, props) || this;
    }
    ErrorMessageWithEmailLink.prototype.render = function () {
        return React.createElement("div", null,
            this.props.Message,
            " ",
            this.props.Email ? React.createElement("a", { href: "mailto:" + this.props.Email }, this.props.Email) : "");
    };
    return ErrorMessageWithEmailLink;
}(React.Component));
exports.ErrorMessageWithEmailLink = ErrorMessageWithEmailLink;
function GetErrorMessageWithEmailLink(Message, Email) {
    return React.createElement(ErrorMessageWithEmailLink, { Message: Message, Email: Email });
}
exports.GetErrorMessageWithEmailLink = GetErrorMessageWithEmailLink;
//# sourceMappingURL=ErrorMessageWithEmailLink.js.map